<template>
  <div class="container">
    <div class="row mt-5 ">
      <div class="col-md-12 col-lg-6">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb bg-white" style="">
            <li class="breadcrumb-item"><a v-bind:href="'/'+cliente"
                                           :style="{'font-size': estilo.unaCategoria.menuUbicacion.font_size+'px', color: estilo.unaCategoria.menuUbicacion.color}">Inicio</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page"
                :style="{'font-size': estilo.unaCategoria.menuUbicacion.font_size+'px', color: estilo.unaCategoria.menuUbicacion.color}">
              {{categorias.categoria}}
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-md-12  col-lg-6">
        <buscador class="ml-2 justify-content-lg-end align-content-center"></buscador>
      </div>
    </div>

    <div class="">
      <h5
        :style="{color: estilo.unaCategoria.tituloPrincipal.color, 'font-size': estilo.unaCategoria.tituloPrincipal.font_size+'px'}"
        class="ml-2 mt-3 font-weight-bold">
        {{ categorias.categoria }}
      </h5>
      <div class="px-0">
        <div id="accordion">
          <div id="scrol" class="container-fluid mb-2" v-for="(contenido, index) in categorias.contenidos">
            <a class="" data-toggle="collapse" v-bind:data-target="'#'+contenido.id" aria-expanded="false"
               aria-controls="collapseOne" @click="estadoContenido('original',contenido.id)"
               v-scroll="handleScroll"
               :style="{color: estilo.unaCategoria.tituloSecundario.color, 'font-size': estilo.unaCategoria.tituloSecundario.font_size+'px'}">
              {{ contenido.titulo }}
              <!-- <i class="fa fa-sort-down" v-if="contenido.id != feclaArribaAbajo"></i>
               <i class="fa fa-sort-up" v-else></i>-->
            </a>
            <div :id="contenido.id" class="collapse" data-parent="#accordion" style="margin-left: 5px">
              <div class="text-justify pr-2" v-html="contenido.contenido">
              </div>
              <div class="card my-2 ">
                <div class="articulo-util" v-if="articuloUtil">
                  <div class="card-header text-center border-bottom-0 border-left-0 border-light-0  pb-0 pt-4">
                    ¿Fue útil este artículo?
                  </div>
                  <div class="card-body text-center">
                    <button type="button" class="btn btn-outline-secondary" style="padding: 10px 44px"
                            @click="contenidoUtil(contenido,'si')">SI
                    </button>
                    <button type="button" class="btn btn-outline-secondary" style="padding: 10px 38px"
                            @click="contenidoUtil(contenido,'no')">NO
                    </button>
                  </div>
                </div>
                <div class="articulo-util" v-else>
                  <div class="card-header text-center border-bottom-0 border-left-0 border-light-0  pb-0 pt-4">
                    <h3>Gracias por su opinión!</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button type="button"
                class="btn btn-outline btn-block btn-sm  text-left ml-3 col-9 col-sm-6 col-md-4 col-xl-3 ml-2 mt-4 mb-3"
                data-toggle="collapse" data-target="#accordion2" aria-expanded="false"
                aria-controls="multiCollapseExample2"
                style="border-radius: 6px; font-size: 15px;"
                @click="masAyudas(categorias)">
          Más ayudas relacionadas<i class="fas fa-arrow-down pl-2 float-right"></i>
        </button>
        <div class="collapse " id="accordion2">
          <div class="container-fluid mb-2" v-for="(contenido, index) in masAyudasData.data">
            <a class="" data-toggle="collapse" v-bind:data-target="'#'+contenido.id" aria-expanded="false"
               aria-controls="collapseOne" @click="estadoContenido('ayudas',contenido.id)"
               v-scroll="handleScroll_ayudas"
               :style="{color: estilo.unaCategoria.tituloSecundario.color, 'font-size': estilo.unaCategoria.tituloSecundario.font_size+'px'}">
              {{ contenido.titulo }}
              <!-- <i class="fa fa-sort-down" v-if="contenido.id != feclaArribaAbajo"></i>
               <i class="fa fa-sort-up" v-else></i>-->
            </a>
            <div :id="contenido.id" class="collapse" data-parent="#accordion2" style="margin-left: 5px">
              <div class="text-justify pr-2" v-html="contenido.contenido">
              </div>
              <div class="card my-2 ">
                <div class="articulo-util" v-if="articuloUtil">
                  <div class="card-header text-center border-bottom-0 border-left-0 border-light-0  pb-0 pt-4">
                    ¿Fue útil este artículo?
                  </div>
                  <div class="card-body text-center">
                    <button type="button" class="btn btn-outline-secondary" style="padding: 10px 44px"
                            @click="contenidoUtil(contenido,'si')">SI
                    </button>
                    <button type="button" class="btn btn-outline-secondary" style="padding: 10px 38px"
                            @click="contenidoUtil(contenido,'no')">NO
                    </button>
                  </div>
                </div>
                <div class="articulo-util" v-else>
                  <div class="card-header text-center border-bottom-0 border-left-0 border-light-0  pb-0 pt-4">
                    <h3>Gracias por su opinión!</h3>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import buscador from '../share/buscador'
  import listApiUrl from '../../compartida/listApiUrl'
  import servicioApi from "../../privada/servicioApi";
  import Vue from 'vue';

  Vue.directive('scroll', {
    inserted: function (el, binding) {
      let f = function (evt) {
        if (binding.value(evt, el)) {
          window.removeEventListener('scroll', f)
        }
      }
      window.addEventListener('scroll', f)
    }
  });

  export default {
    name: "cuerpo",
    data() {
      return {
        categorias: {},
        cliente: '',
        feclaArribaAbajo: '',
        articuloUtil: true,
        masAyudasData: {},
        handleScrollOriginal: null,
        handleScrollAyudas: null,
        estilo: {
          unaCategoria: {
            menuUbicacion: {font_size: '', color: ''},
            tituloPrincipal: {color: '', font_size: ''},
            tituloSecundario: {color: '', font_size: ''}
          }
        }
      }
    },
    components: {
      buscador
    },
    created() {
      EventBus.$on('unaCategoria', this.estilos);
      this.cliente = this.$route.params.cliente;
      let categoria = this.$route.params.categoria;

      axios.get(`${listApiUrl.BASE_URL_PRODUCCION + listApiUrl.API_URL_PUBLICO + listApiUrl.API_URL_PUBLICO_CATEGORIA}/${categoria}/${this.cliente}`)
        .then(response => {
          this.categorias = response.data.data[0];
          EventBus.$emit('nombreEmpresa', response.data.data[0].cliente.nombre);
          for (let categoriasKey in this.categorias.contenidos) {
            let utilArticulo = localStorage.getItem('articulo_util_' + this.categorias.contenidos[categoriasKey].id + '_' + this.categorias.contenidos[categoriasKey].titulo);

            if (utilArticulo != undefined && utilArticulo != '' && utilArticulo != null && utilArticulo == "true")
              this.categorias.contenidos[categoriasKey]['estadoEncuesta'] = false;
            else
              this.categorias.contenidos[categoriasKey]['estadoEncuesta'] = true;
          }

        })
        .catch(e => {
          console.log(e);
        });
    },
    methods: {
      estilos: function (data) {
        // console.log(162+' Estilos una categoiria',data.unaCategoria);
        this.estilo.unaCategoria = data.unaCategoria;
        this.estilo.unaCategoria.menuUbicacion.font_size = data.unaCategoria.menuUbicacion['font-size'];
        this.estilo.unaCategoria.tituloSecundario.font_size = data.unaCategoria.tituloSecundario['font-size'];
        this.estilo.unaCategoria.tituloPrincipal.font_size = data.unaCategoria.tituloPrincipal['font-size'];
      },
      estadoContenido: function (tipo, el, data) {
        if (this.feclaArribaAbajo != data) {
          this.feclaArribaAbajo = data;
        }
        else
          this.feclaArribaAbajo = '';

        let utilArticulo = localStorage.getItem('articulo_util_' + data);
        if (utilArticulo != undefined && utilArticulo != '' && utilArticulo != null && utilArticulo == "true") {
          this.articuloUtil = false;
        }

        /*let scrolY = window.scrollY;
        let elHeight = $('#' + el).height();

        if (scrolY > elHeight) {
          window.scrollTo(window.scrollY, scrolY);
        } else {*/
        if (tipo == 'original')
          window.scrollTo(0, this.handleScrollOriginal + 10);
        else {
          window.scrollTo(0, this.handleScrollAyudas + 10);
        }
        // }

      },
      masAyudas: function (categorias) {
        servicioApi.rol_regular.masAyudas.getMasAyudasPublico(categorias.id).then(resp => {
          console.log(resp);
          this.masAyudasData = resp.data;
        }).catch(e => {
        })
      },
      contenidoUtil: function (contenido, tipo_util) {
        console.log(contenido);
        axios.post(`${listApiUrl.BASE_URL_PRODUCCION + listApiUrl.API_URL_PUBLICO + listApiUrl.API_URL_PUBLICO_CONTENIDO}/util/${contenido.id}/tipo-util/${tipo_util}`)
          .then(response => {
            if (response.status == 200) {
              this.articulo_util(contenido);
              contenido.estadoEncuesta = false;
            }
          }).catch(e => {
          console.log(e);
        });
      }, articulo_util: function (contenido) {
        localStorage.setItem('articulo_util_' + contenido.id + '_' + contenido.titulo, true);
        this.articuloUtil = false;
      },
      handleScroll: function (evt, el) {
        console.log(window.scrollY)
        this.handleScrollOriginal = window.scrollY;
        return window.scrollY > 100
      },
      handleScroll_ayudas: function (evt, el) {
        console.log(window.scrollY)
        this.handleScrollAyudas = window.scrollY;
        // return window.scrollY > 100
      },
    }
  }
</script>

<style scoped lang="scss">
  .card, .card-body, .car-footer, .card-header {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.0), 0 0 0 0 rgba(0, 0, 0, .0), 0 0 0 0 rgba(0, 0, 0, .0);
    -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.0), 0 0 0 0 rgba(0, 0, 0, .0), 0 0 0 0 rgba(0, 0, 0, .0);
  }

  .card-footer {
    border-top: 1px solid rgba(0, 0, 0, .0);
  }

  .custom-select:focus {
    background-size: 8px 10px;
    border: 1px solid rgba(0, 0, 0, .26);
    border-radius: .125rem;
    -webkit-appearance: none;

    border-color: rgba(0, 0, 0, .26);
    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
  }
</style>



// WEBPACK FOOTER //
// src/components/publico/fragmentosUnaCategoria/cuerpo.vue